export const environment = {
    production: false,
    domainBackEnd:".",
    APIKey: "3_fobFGkBfAeVpo6RY374XYdYKntXB7LkKnXCa6F6sBLZ9RTyaQZgus5bFcTLrE7-1"//#gitleaks:allow

};
